import { tokens } from "./tokens";

/** Theme object consumed by ThemeProvider and component helpers. */
export const theme = {
  ...tokens,
  name: "huddl-hq" as const,
};

export type HuddlTheme = typeof theme;
